<siat-loading-spinner [visible]="loadingStore.loading()"></siat-loading-spinner>
<router-outlet></router-outlet>
